import { useState, useCallback } from 'react';

const WAIT_BEFORE_NEXT_MS = 1000;

export function useHotspotTour(hotspots, { loop = false } = {}) {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isWaitingForNext, setIsWaitingForNext] = useState(false);
    const [displayedCount, setDisplayedCount] = useState(0);

    const openModal = useCallback(() => {
        setIsModalOpen(true);
        setDisplayedCount(currentIndex + 1); 
    }, [currentIndex]);

    const closeModal = useCallback(() => {
        const total = hotspots?.length ?? 0;
        const isLastHotspot = currentIndex >= total - 1;

        setIsModalOpen(false);
        setIsWaitingForNext(true);

        const timer = setTimeout(() => {
            if (loop && isLastHotspot) {
                setCurrentIndex(0);
                setDisplayedCount(0);
            } else {
                setCurrentIndex((prev) => prev + 1);
            }
            setIsWaitingForNext(false);
        }, WAIT_BEFORE_NEXT_MS);

        return () => clearTimeout(timer);
    }, [hotspots?.length, currentIndex, loop]);

    return {
        currentIndex,
        displayedCount,
        isModalOpen,
        isWaitingForNext,
        openModal,
        closeModal,
        total: hotspots?.length ?? 0,
    };
}
